import { createReducer, on } from '@ngrx/store';
import { fastrNotesLoad } from './notes.actions';
import { mojoNotesLoadSuccess, NoteSubject } from 'mojo-irp-notes';

export interface NotesState {
  subjectType?: NoteSubject;
  subjectId: string | null;
  pageNumber: number;
  moreElements: boolean;
}

const initialState: NotesState = {
  subjectType: undefined,
  subjectId: null,
  pageNumber: 0,
  moreElements: true,
};

export const notesReducer = createReducer(
  initialState,
  on(fastrNotesLoad, (state, { subjectType, subjectId, pageNumber }) => ({
    ...state,
    subjectId,
    subjectType,
    pageNumber,
  })),
  on(mojoNotesLoadSuccess, (state, { payload }) => ({
    ...state,
    moreElements: !payload.last,
  })),
);
